import { render } from "./NewsHp.vue?vue&type=template&id=312beeea"
import script from "./NewsHp.vue?vue&type=script&lang=js"
export * from "./NewsHp.vue?vue&type=script&lang=js"

import "./NewsHp.vue?vue&type=style&index=0&id=312beeea&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__